import request from '@/router/axios'
import env from '@/config/env'

/**
 *
 * @param param 查询参数
 * @returns {*}
 */
export const getInsurancePage = (param) => {
    return request({
        url: env.ferryUrl+'/insurance/insurance/page',
        method: 'POST',
        data: param
    })
}


/**
 * 新增或编辑保险
 * @param param
 * @returns {*}
 */
export const  addOrEditInsurance = (param) => {
    return request({
        url: env.ferryUrl+'/insurance/saveOrUpdate',
        method: 'POST',
        data: param
    })
}


/**
 * 根据保险id获取保险详情
 * @param insuranceId
 * @returns {*}
 */
export const getInsuranceInfo = (insuranceId) => {
    return request({
        url: env.ferryUrl+`/insurance/selectById/${insuranceId}`,
        method: 'GET'
    })
}


/**
 * 根据参数获取保单分页数据
 * @returns {*}
 */
export const getPolicyPage = (policyParam) => {
    return request({
        url: env.ferryUrl+'/insurance/insureOrder/page',
        method: 'POST',
        data: policyParam
    })
}


/**
 * 导出保单数据
 * @param param
 * @returns {*}
 */
export const exportPolicy = (param) => {
    return request({
        url: env.ferryUrl+'/insurance/export/insuranceOrder',
        method: 'POST',
        data: param
    })
}

/**
 * 获取有效的保险
 * @returns {*}
 */
export const selectInsureValid = () => {
    return request({
        url: env.ferryUrl+'/insurance/getValidInsureance',
        method: 'GET',
    })
}
